/**
 * Created by 唐亦慧 on 2017/8/29.
 */

import {config, request, objectSerial} from 'Utils';


//获取账号列表
export function accountList(param) {
	return request(`${config.server}/api/v1/dms/user/list`,{
		method: 'post',
		body: param
	});
}

//获取账号审核
export function accountAudit(param) {
	return request(`${config.server}/api/v1/dms/user/audit`,{
		method: 'post',
		body: param
	});
}

//禁用账号
export function accountInvalid(param) {
	return request(`${config.server}/api/v1/dms/user/invalid?${objectSerial(param)}`);
}

//启用账号
export function accountValid(param) {
	return request(`${config.server}/api/v1/dms/user/valid?${objectSerial(param)}`);
}

//重置密码
export function accountResetPwd(param) {
	return request(`${config.server}/api/v1/dms/user/resetPwd?${objectSerial(param)}`,{method: 'post'});
}


/******************* 商品选型库 start *********************/

//获取用户信息
export function getUserDetail() {
	return request(`${config.server}/user/v6/getUserDetail`);
}

//获取用户信息
export function modifyUserInfo(param) {
	return request(`${config.server}/api/v2/dms/user/modifyUserInfo`, {
		method: 'post',
		body: param
	});
}

//收货地址列表
export function addressList(param) {
	return request(`${config.server}/api/v2/dms/user/addressList`, {
		method: 'post',
		body: param
	});
}
//设置默认收货地址
export function defaultAddress(id) {
	return request(`${config.server}/api/v2/dms/user/defaultAddress?id=${id}`, {
		method: 'post',
	});
}
//删除收货地址
export function deleteAddress(id) {
	return request(`${config.server}/api/v2/dms/user/deleteAddress?id=${id}`);
}
//获取默认收货地址
export function getDefaultAddress() {
	return request(`${config.server}/api/v2/dms/user/getDefaultAddress`, {
		method: 'post',
	});
}
//获取默认收货地址
export function saveOrModifyAddress(param) {
	return request(`${config.server}/api/v2/dms/user/saveOrModifyAddress`, {
		method: 'post',
		body: param
	});
}
/******************* 商品选型库 end *********************/



// WEBPACK FOOTER //
// ./src/service/account/index.js